export enum SiteViewportActionType {
  SetFullscreen = 'site_viewport/SET_FULLSCREEN',
  SetRotated = 'site_viewport/SET_ROTATED',
  SetSelectorVisible = 'site_viewport/SET_SELECTOR_VISIBLE',
  SetSize = 'site_viewport/SET_SIZE',
}
